var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Donor")]),_c('DonorType',{model:{value:(_vm.form.data.funeral.details.donorOption),callback:function ($$v) {_vm.$set(_vm.form.data.funeral.details, "donorOption", $$v)},expression:"form.data.funeral.details.donorOption"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }